<div *ngIf="!isAdmin" class="main-content">
    <div class="card">
        <p-toolbar styleClass="p-mb-4">
            <ng-template pTemplate="left"></ng-template>
            <ng-template pTemplate="right">
                <button pButton pRipple label="{{ 'OFFERS.REQUEST_UPDATE' | translate }}" icon="pi pi-plus"
                        class="p-button-success mr-2 njoyButton" (click)="sendMail()"></button>
            </ng-template>
        </p-toolbar>
        <p-table #dt [value]="offers" [rows]="10" [paginator]="true"
                 [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="name">{{ 'OFFERS.LABEL' | translate }}
                        <p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th>{{ 'PARTNER.IMAGE_LABEL' | translate }}</th>
                    <th>{{ 'PARTNER.DESCRIPTION_LABEL' | translate }}</th>
                    <th>{{ 'OFFERS.INITIAL_PRICE_LABEL' | translate }}</th>
                    <th>{{ 'OFFERS.BUYING_PRICE_LABEL' | translate }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-offer>
                <tr>
                    <td>{{offer.label}}</td>
                    <td><img [src]="offer?.imagePath"
                             width="100" class="p-shadow-4"/></td>
                    <td>{{offer?.description}}</td>
                    <td>{{offer?.initialPrice| currency:'EUR'}}</td>
                    <td>{{offer?.buyingPrice | currency:'EUR'}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <p-dialog [(visible)]="updateRequestModal" [modal]="true" [style]="{width: '20vw'}"
              [draggable]="false" [resizable]="false">
        <p class="p-m-0">{{ 'OFFERS.REQUEST_UPDATE_SUCCESS' | translate }}</p>
        <ng-template pTemplate="footer">
            <p-button icon="pi pi-check" (click)="updateRequestModal=false" label="Ok" styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog>
</div>

<div *ngIf="isAdmin" class="card">
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left"></ng-template>
        <ng-template pTemplate="right">
            <button pButton pRipple label="{{ 'OFFERS.ADD_NEW' | translate }}" icon="pi pi-plus"
                    class="p-button-success mr-2 njoyButton" (click)="addNew()"></button>
        </ng-template>
    </p-toolbar>
    <p-table #dt [value]="offers" [rows]="10" [paginator]="true" [rowHover]="true"
             [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="name">{{ 'OFFERS.LABEL' | translate }}
                    <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th>{{ 'PARTNER.IMAGE_LABEL' | translate }}</th>
                <th>{{ 'PARTNER.DESCRIPTION_LABEL' | translate }}</th>
                <th>{{ 'OFFERS.INITIAL_PRICE_LABEL' | translate }}</th>
                <th>{{ 'OFFERS.BUYING_PRICE_LABEL' | translate }}</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-offer>
            <tr (dblclick)="openUpdateModal(offer)">
                <td>{{offer.label}}</td>
                <td><img [src]="offer?.imagePath"
                         width="100" class="p-shadow-4"/></td>
                <td>{{offer?.description}}</td>
                <td>{{offer?.initialPrice| currency:'EUR'}}</td>
                <td>{{offer?.buyingPrice | currency:'EUR'}}</td>
                <td>
                    <button pButton pRipple icon="pi pi-times" class="p-button-rounded njoyButton"
                            (click)="confirmDeleteOffer(offer)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog *ngIf="addNewOfferDialog" [(visible)]="addNewOfferDialog" [style]="{width: '600px'}"
          [header]="modalTitle" [modal]="true"
          styleClass="p-fluid">

    <div class="container-fluid">
        <form [formGroup]="offerForm">
            <div class="row">
                <div class="col-md-4 mt-4">
                    <mat-label>{{ 'CATEGORY.LABEL' | translate }} *</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="label"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.label?.errors?.required">
                            {{ 'CATEGORY.LABEL_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-4 mt-5">
                    <mat-label>{{ 'CATEGORY.BACKGROUND_IMAGE' | translate }} *</mat-label>
                </div>
                <div class="col-md-8" *ngIf="isAddAction">
                    <p-fileUpload #fileUpload (onSelect)="onUpload($event)" (onClear)="clearFile()"
                                  (onRemove)="clearFile()"
                                  [showUploadButton]="false"
                                  accept="image/*">
                    </p-fileUpload>
                    <mat-error style="font-size: 75%;" *ngIf="noFileUploaded">
                        {{ 'PARTNER.IMAGE_REQUIRED_LABEL' | translate }}
                        <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                    </mat-error>
                </div>
                <div class="col-md-8" *ngIf="!isAddAction">
                    <span class="logo-tooltip" (click)="changeImageValue()">
                        <img [src]="selectedOffer?.imagePath" class="middle-logo"/>
                    </span>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-4 mt-5">
                    <mat-label>{{ 'PARTNER.DESCRIPTION_LABEL' | translate }}</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <textarea matInput formControlName="description"
                                  rows="5"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-4 mt-4">
                    <mat-label>{{ 'OFFERS.INITIAL_PRICE_LABEL' | translate }} *</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="initialPrice"
                               [errorStateMatcher]="matcher" type="number">
                        <mat-error *ngIf="getControl?.initialPrice?.errors?.min">
                            {{ 'OFFERS.VALUE_MUST_BE_ERROR' | translate }}
                            <strong>{{ 'OFFERS.VALUE_BIGGER_THAN_ZERO_ERROR' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-4 mt-4">
                    <mat-label>{{ 'OFFERS.BUYING_PRICE_LABEL' | translate }} *</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="buyingPrice"
                               [errorStateMatcher]="matcher" type="number">
                        <mat-error *ngIf="getControl?.buyingPrice?.errors?.min">
                            {{ 'OFFERS.VALUE_MUST_BE_ERROR' | translate }}
                            <strong>{{ 'OFFERS.VALUE_BIGGER_THAN_ZERO_ERROR' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{ 'BUTTONS.SAVE' | translate }}" icon="pi pi-check" class="p-button-text"
                (click)="addOrUpdateOffer()"></button>
    </ng-template>
</p-dialog>
<p-toast></p-toast>
<p-confirmDialog #cd header="Confirmation"
                 icon="pi pi-exclamation-triangle"
                 acceptLabel="{{ 'BUTTONS.YES' | translate }}"
                 rejectLabel="{{ 'BUTTONS.NO' | translate }}"
>
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    </ng-template>
</p-confirmDialog>
